import { render, staticRenderFns } from "./PostPurchase.vue?vue&type=template&id=3ba15743&scoped=true&"
import script from "./PostPurchase.vue?vue&type=script&lang=js&"
export * from "./PostPurchase.vue?vue&type=script&lang=js&"
import style0 from "./PostPurchase.vue?vue&type=style&index=0&id=3ba15743&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba15743",
  null
  
)

export default component.exports